 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import {PALETTE} from '../styles/paletteV3'
import {LocalStorageKey} from '../types/constEnums'

 


const THEME_PREFERENCES = ['light', 'dark', 'system']

export const isThemePreference = (value) =>
  THEME_PREFERENCES.includes(value )

export const resolveTheme = (
  preference,
  systemPrefersDark
) => {
  if (preference === 'system') return systemPrefersDark ? 'dark' : 'light'
  return preference
}

const DEFAULT_THEME_PREFERENCE = 'system'

export const getStoredThemePreference = () => {
  try {
    const stored = window.localStorage.getItem(LocalStorageKey.THEME)
    return isThemePreference(stored) ? stored : DEFAULT_THEME_PREFERENCE
  } catch (e) {
    return DEFAULT_THEME_PREFERENCE
  }
}

export const setStoredThemePreference = (preference) => {
  try {
    window.localStorage.setItem(LocalStorageKey.THEME, preference)
  } catch (e2) {}
}

export const applyTheme = (theme) => {
  document.documentElement.classList.toggle('theme-dark', theme === 'dark')
  _optionalChain([document
, 'access', _ => _.querySelector, 'call', _2 => _2('meta[name="theme-color"]')
, 'optionalAccess', _3 => _3.setAttribute, 'call', _4 => _4('content', theme === 'dark' ? PALETTE.GRAPE_800 : PALETTE.GRAPE_700)])
}
